import { useEffect, useRef, useState } from "react";
import { apiWebNew } from "../../../library/axios";
import { MessageResponse } from "../../../model/MessageResponse";
import { Box, Button, Flex, Paper, Title } from "@mantine/core";
import { IconBox } from "@tabler/icons-react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";

export default function DataSynchronization() {
  const [loading, setLoading] = useState(false);
  const [height, setHeight] = useState(0);
  const headerRef = useRef<HTMLDivElement>(null);

  const handleSyncProducts = async () => {
    setLoading(true);
    try {
      const res = await apiWebNew.get<MessageResponse<any>>("/Home/sync-item");
      if (
        res &&
        res.data &&
        typeof res.data.success !== "undefined" &&
        res.data.httpStatusCode === 200
      ) {
        if (res.data.success) {
          NotificationExtension.Success("Đồng bộ sản phẩm thành công!");
        } else {
          NotificationExtension.Fails(res.data.message || "Đồng bộ thất bại.");
        }
      } else {
        NotificationExtension.Fails("Phản hồi không hợp lệ từ máy chủ.");
      }
    } catch (err: any) {
      NotificationExtension.Fails("Đã xảy ra lỗi khi đồng bộ sản phẩm.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (300 + headerHeight));
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        border: "1px solid #dee2e6",
        padding: 10,
        overflow: "hidden",
        height: height,
      }}
      ref={headerRef}
    >
      
      <Flex
        gap="md"
        justify="space-between"
        align="center"
        direction="row"
        wrap="wrap"
        w="100%"
      >
        <BreadCrumb />
      </Flex>
      <Box mt={30}>
        <Button
          leftSection={<IconBox size={22} />}
          color="blue"
          size="md"
          radius="md"
          loading={loading}
          onClick={handleSyncProducts}
          style={{ minWidth: 220 }}
        >
          Đồng bộ sản phẩm
        </Button>
      </Box>
    </div>
  );
}
